// extracted by mini-css-extract-plugin
export default {"pager":"Pager_pager__2JSIC","numberBlocks":"Pager_numberBlocks__-bw0s","gap":"Pager_gap__npztQ","number":"Pager_number__HeItg","nextPrev":"Pager_nextPrev__rQ3oy"};